import Ajv from 'ajv'
import moment from 'moment'


const issueNumberRegex = new RegExp(/^\d{4}\/\d{5}$/)

export const _issueNumberFormat = (value: string): boolean => {
    if (!issueNumberRegex.test(value)) return false // fail if number does not match schema

    const year = value.split('/')[0]
    return Number(year) <= moment().year() // fail if year portion is in the future
}

export const issueNumberFormat = (ajv: Ajv) => {
    ajv.addFormat('issueNumber', _issueNumberFormat)
}
